// src/components/create-project/ProjectForm/steps/Step2UseCases.tsx
import { FC } from 'react';
import { USE_CASES } from '@/components/create-project/utils/constants';
import { ProjectFormData } from '@/components/create-project/types/project';
import { Card } from '@/components/ui/card';
import { Check } from 'lucide-react';

interface StepProps {
  formData: ProjectFormData;
  updateField: (key: keyof ProjectFormData, value: any) => void;
  errors: Record<string, string>;
}

export const Step2UseCases: FC<StepProps> = ({ formData, updateField, errors }) => {
  const toggleUseCase = (value: string) => {
    const newUseCases = formData.useCases.includes(value)
      ? formData.useCases.filter(u => u !== value)
      : [...formData.useCases, value];
    updateField('useCases', newUseCases);
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        {USE_CASES.map(({ value, icon: Icon, description }) => (
          <Card
            key={value}
            className={`p-4 cursor-pointer relative bg-primary-50 rounded-lg ${
              formData.useCases.includes(value) ? 'border-primary' : ''
            }`}
            onClick={() => toggleUseCase(value)}
          >
            <div className="flex items-start gap-4">
              <Icon className="h-6 w-6 mt-1" />
              <div>
                <h3 className="font-medium">{value}</h3>
                <p className="text-sm text-muted-foreground">{description}</p>
              </div>
              {formData.useCases.includes(value) && (
                <Check className="h-5 w-5 text-primary absolute top-4 right-4" />
              )}
            </div>
          </Card>
        ))}
      </div>
      {errors.useCases && (
        <p className="text-red-500 text-sm">{errors.useCases}</p>
      )}
    </div>
  );
};